import React, { useContext } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import { Pane, Theme } from '@leverege/ui-elements';
import useExtensions from "./textEditor/extensions/useExtensions.js";
import S from './CustomTextDetailRenderer.css';
import { jsx as _jsx } from "react/jsx-runtime";
function EditorComponent(props) {
  const {
    object,
    cxt,
    value
  } = props;
  const extensions = useExtensions();
  const theme = useContext(Theme.Context);
  const editor = useEditor({
    extensions,
    content: value,
    editable: false,
    editorProps: {
      object,
      context: cxt,
      theme
    }
  }, [object, cxt, value]);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "attributeCustomText",
    style: {
      width: '100%',
      overflow: 'visible'
    },
    children: /*#__PURE__*/_jsx(EditorContent, {
      className: S.editor,
      editor: editor
    })
  });
}
export default class CustomTextDetailRenderer {
  constructor(detail) {
    this.detail = detail;
  }
  getComponents(object, cxt) {
    return {
      component: /*#__PURE__*/React.createElement(EditorComponent, {
        value: this.detail.html,
        object,
        cxt
      })
    };
  }
}